"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Builder = _interopRequireDefault(require("./Builder.js"));

var _Instruction = _interopRequireWildcard(require("./Instruction.js"));

var _canvas = require("../canvas.js");

var _simplify = require("../../geom/flat/simplify.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/render/canvas/PolygonBuilder
 */


var CanvasPolygonBuilder =
/** @class */
function (_super) {
  __extends(CanvasPolygonBuilder, _super);
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */


  function CanvasPolygonBuilder(tolerance, maxExtent, resolution, pixelRatio) {
    return _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */


  CanvasPolygonBuilder.prototype.drawFlatCoordinatess_ = function (flatCoordinates, offset, ends, stride) {
    var state = this.state;
    var fill = state.fillStyle !== undefined;
    var stroke = state.strokeStyle !== undefined;
    var numEnds = ends.length;
    this.instructions.push(_Instruction.beginPathInstruction);
    this.hitDetectionInstructions.push(_Instruction.beginPathInstruction);

    for (var i = 0; i < numEnds; ++i) {
      var end = ends[i];
      var myBegin = this.coordinates.length;
      var myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
      var moveToLineToInstruction = [_Instruction["default"].MOVE_TO_LINE_TO, myBegin, myEnd];
      this.instructions.push(moveToLineToInstruction);
      this.hitDetectionInstructions.push(moveToLineToInstruction);

      if (stroke) {
        // Performance optimization: only call closePath() when we have a stroke.
        // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
        this.instructions.push(_Instruction.closePathInstruction);
        this.hitDetectionInstructions.push(_Instruction.closePathInstruction);
      }

      offset = end;
    }

    if (fill) {
      this.instructions.push(_Instruction.fillInstruction);
      this.hitDetectionInstructions.push(_Instruction.fillInstruction);
    }

    if (stroke) {
      this.instructions.push(_Instruction.strokeInstruction);
      this.hitDetectionInstructions.push(_Instruction.strokeInstruction);
    }

    return offset;
  };
  /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   */


  CanvasPolygonBuilder.prototype.drawCircle = function (circleGeometry, feature) {
    var state = this.state;
    var fillStyle = state.fillStyle;
    var strokeStyle = state.strokeStyle;

    if (fillStyle === undefined && strokeStyle === undefined) {
      return;
    }

    this.setFillStrokeStyles_();
    this.beginGeometry(circleGeometry, feature);

    if (state.fillStyle !== undefined) {
      this.hitDetectionInstructions.push([_Instruction["default"].SET_FILL_STYLE, _canvas.defaultFillStyle]);
    }

    if (state.strokeStyle !== undefined) {
      this.hitDetectionInstructions.push([_Instruction["default"].SET_STROKE_STYLE, state.strokeStyle, state.lineWidth, state.lineCap, state.lineJoin, state.miterLimit, state.lineDash, state.lineDashOffset]);
    }

    var flatCoordinates = circleGeometry.getFlatCoordinates();
    var stride = circleGeometry.getStride();
    var myBegin = this.coordinates.length;
    this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
    var circleInstruction = [_Instruction["default"].CIRCLE, myBegin];
    this.instructions.push(_Instruction.beginPathInstruction, circleInstruction);
    this.hitDetectionInstructions.push(_Instruction.beginPathInstruction, circleInstruction);

    if (state.fillStyle !== undefined) {
      this.instructions.push(_Instruction.fillInstruction);
      this.hitDetectionInstructions.push(_Instruction.fillInstruction);
    }

    if (state.strokeStyle !== undefined) {
      this.instructions.push(_Instruction.strokeInstruction);
      this.hitDetectionInstructions.push(_Instruction.strokeInstruction);
    }

    this.endGeometry(feature);
  };
  /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */


  CanvasPolygonBuilder.prototype.drawPolygon = function (polygonGeometry, feature) {
    var state = this.state;
    var fillStyle = state.fillStyle;
    var strokeStyle = state.strokeStyle;

    if (fillStyle === undefined && strokeStyle === undefined) {
      return;
    }

    this.setFillStrokeStyles_();
    this.beginGeometry(polygonGeometry, feature);

    if (state.fillStyle !== undefined) {
      this.hitDetectionInstructions.push([_Instruction["default"].SET_FILL_STYLE, _canvas.defaultFillStyle]);
    }

    if (state.strokeStyle !== undefined) {
      this.hitDetectionInstructions.push([_Instruction["default"].SET_STROKE_STYLE, state.strokeStyle, state.lineWidth, state.lineCap, state.lineJoin, state.miterLimit, state.lineDash, state.lineDashOffset]);
    }

    var ends = polygonGeometry.getEnds();
    var flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
    var stride = polygonGeometry.getStride();
    this.drawFlatCoordinatess_(flatCoordinates, 0,
    /** @type {Array<number>} */
    ends, stride);
    this.endGeometry(feature);
  };
  /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */


  CanvasPolygonBuilder.prototype.drawMultiPolygon = function (multiPolygonGeometry, feature) {
    var state = this.state;
    var fillStyle = state.fillStyle;
    var strokeStyle = state.strokeStyle;

    if (fillStyle === undefined && strokeStyle === undefined) {
      return;
    }

    this.setFillStrokeStyles_();
    this.beginGeometry(multiPolygonGeometry, feature);

    if (state.fillStyle !== undefined) {
      this.hitDetectionInstructions.push([_Instruction["default"].SET_FILL_STYLE, _canvas.defaultFillStyle]);
    }

    if (state.strokeStyle !== undefined) {
      this.hitDetectionInstructions.push([_Instruction["default"].SET_STROKE_STYLE, state.strokeStyle, state.lineWidth, state.lineCap, state.lineJoin, state.miterLimit, state.lineDash, state.lineDashOffset]);
    }

    var endss = multiPolygonGeometry.getEndss();
    var flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
    var stride = multiPolygonGeometry.getStride();
    var offset = 0;

    for (var i = 0, ii = endss.length; i < ii; ++i) {
      offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
    }

    this.endGeometry(feature);
  };
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */


  CanvasPolygonBuilder.prototype.finish = function () {
    this.reverseHitDetectionInstructions();
    this.state = null; // We want to preserve topology when drawing polygons.  Polygons are
    // simplified using quantization and point elimination. However, we might
    // have received a mix of quantized and non-quantized geometries, so ensure
    // that all are quantized by quantizing all coordinates in the batch.

    var tolerance = this.tolerance;

    if (tolerance !== 0) {
      var coordinates = this.coordinates;

      for (var i = 0, ii = coordinates.length; i < ii; ++i) {
        coordinates[i] = (0, _simplify.snap)(coordinates[i], tolerance);
      }
    }

    return _super.prototype.finish.call(this);
  };
  /**
   * @private
   */


  CanvasPolygonBuilder.prototype.setFillStrokeStyles_ = function () {
    var state = this.state;
    var fillStyle = state.fillStyle;

    if (fillStyle !== undefined) {
      this.updateFillStyle(state, this.createFill);
    }

    if (state.strokeStyle !== undefined) {
      this.updateStrokeStyle(state, this.applyStroke);
    }
  };

  return CanvasPolygonBuilder;
}(_Builder["default"]);

var _default = CanvasPolygonBuilder;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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